/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { landingLogo } from "../assets";
import Utility from "../utility/utility";
import { BASE_URL } from "../services/environment";

const AdminAuth = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [adminData, setAdminData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAdminData({
      ...adminData,
      [name]: value,
    });
  };

  // Update the handleSubmit function
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isLogin && adminData.password !== adminData.confirmPassword) {
      Utility.showToast("error", "Passwords do not match");
      return;
    }

    try {
      const endpoint = isLogin ? `${BASE_URL}/api/admin/login` : `${BASE_URL}/api/admin/register`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: adminData.email,
          password: adminData.password,
        }),
      });

      const data = await response.json();

      if (data.status_code === 200) {
        // Store admin credentials in localStorage
        localStorage.setItem("adminId", data.data.admin_id);
        localStorage.setItem("adminApiKey", data.data.api_key);
        localStorage.setItem("adminEmail", data.data.email);
        
        Utility.showToast("success", data.message);
        
        // If it's registration, show the API key warning
        // if (!isLogin && data.data.message) {
        //   alert(`IMPORTANT: Save your API key securely:\n\n${data.data.api_key}\n\nYou will need it for all admin requests.`);
        // }
        
        navigate("/admin/dashboard");
      } else {
        Utility.showToast("error", data.message || "Authentication failed");
      }
    } catch (error) {
      Utility.showToast("error", "An error occurred. Please try again.");
    }
  };

  return (
    <div className="background">
      <div className="container">
        <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
          <div className="text-center mb-4">
            <img src={landingLogo} className="width-set-home" />
            <h2 className="text-white semi-bold mt-3">Facilitator {isLogin ? "Login" : "Sign Up"}</h2>
          </div>
          
          <div className="" style={{ width: "100%", maxWidth: "400px" }}>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label text-white h3">Email</label>
                <input
                  type="email"
                  className="form-control semi-bold"
                  id="email"
                  name="email"
                  value={adminData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label text-white h3">Password</label>
                <input
                  type="password"
                  className="form-control semi-bold"
                  id="password"
                  name="password"
                  value={adminData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              {!isLogin && (
                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label text-white h3">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control semi-bold"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={adminData.confirmPassword}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              )}
              
              <button type="submit" className="btn border-name-button semi-bold">
                {isLogin ? "Login" : "Sign Up"}
              </button>
              
              {/* <div className="text-center text-white">
                <button
                  type="button"
                  className="btn btn-link text-white mt-3"
                  onClick={() => setIsLogin(!isLogin)}
                >
                  {isLogin ? "Don't have an account? Sign Up" : "Already have an account? Login"}
                </button>
              </div> */}
            </form>
          </div>
          
          <div className="btn border-name-button semi-bold">
            <button
              onClick={() => navigate("/")}
              type="button"
              className="btn border-name-button semi-bold"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;